export default function FlowSection() {
  const steps = [
    {
      number: '01',
      title: 'お問い合わせ',
      description: 'お電話またはLINEで、お気軽にご連絡ください。ご都合の良い日時をお伺いします。',
      icon: 'ri-phone-line',
    },
    {
      number: '02',
      title: 'カウンセリング',
      description: 'お悩みや痛みの状態について、じっくりお話を伺います。どんな小さなことでも遠慮なくお聞かせください。',
      icon: 'ri-chat-3-line',
    },
    {
      number: '03',
      title: '身体の状態チェック',
      description: '痛みの原因を見極めるため、姿勢や動き、バランスなどを丁寧に確認します。',
      icon: 'ri-search-eye-line',
    },
    {
      number: '04',
      title: '施術',
      description: 'お一人おひとりの状態に合わせて、全身のバランスを整えていきます。痛みのない、やさしい施術です。',
      icon: 'ri-hand-heart-line',
    },
    {
      number: '05',
      title: 'アフターケア',
      description: '施術後の変化を確認し、日常生活でのアドバイスをお伝えします。ご不安なことがあれば、いつでもご相談ください。',
      icon: 'ri-heart-pulse-line',
    },
  ];

  return (
    <section id="flow" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-6">
            <span className="px-5 py-2 bg-[#10B981] text-white text-sm font-medium rounded-full">
              Treatment Flow
            </span>
          </div>
          <h2 className="text-5xl font-bold text-[#065F46] mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            整体の流れ
          </h2>
          <p className="text-lg text-[#666666] mt-6">初めての方も安心してご利用いただけます</p>
        </div>

        <div className="max-w-4xl mx-auto space-y-8">
          {[
            { step: '01', title: 'お身体の状態の確認', description: '現在のお悩みや症状について、丁寧にお伺いします。痛みの場所、いつから始まったか、どのような時に痛むかなど、詳しくお聞かせください。', icon: 'ri-questionnaire-line' },
            { step: '02', title: '身体の動きのチェック', description: '実際に身体を動かしていただき、動きの癖や制限を確認します。日常生活での身体の使い方を観察し、問題点を見つけ出します。', icon: 'ri-search-eye-line' },
            { step: '03', title: 'リラックスした状態での施術', description: '問題点を追及しながら丁寧にアプローチいたします。強い力は一切使わず、軽く触れるだけの身体にやさしい施術を行います。リラックスすることで、施術の効果もより高まります。', icon: 'ri-hand-heart-line' },
            { step: '04', title: '日常生活のアドバイス', description: '施術後も効果が持続するよう、日常生活での身体の使い方や、簡単にできるセルフケアの方法をお伝えします。', icon: 'ri-lightbulb-line' }
          ].map((flow, index) => (
            <div key={index} className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-[#ECFDF5] hover:border-[#10B981]">
              <div className="flex flex-col md:flex-row gap-6">
                <div className="flex-shrink-0">
                  <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-[#10B981] to-[#059669] rounded-2xl shadow-lg">
                    <i className={`${flow.icon} text-3xl text-white`}></i>
                  </div>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-4 mb-4">
                    <span className="px-4 py-1 bg-[#ECFDF5] text-[#10B981] text-sm font-bold rounded-full">STEP {flow.step}</span>
                    <h3 className="text-2xl font-bold text-[#065F46]" style={{ fontFamily: "'Noto Serif JP', serif" }}>{flow.title}</h3>
                  </div>
                  <p className="text-base text-[#666666] leading-relaxed">{flow.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
